import { biToast } from '@pulsepointinc/bi-components';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { ApiError } from '../../lib/api';
import { fetchGetHierarchies, type GetHierarchiesRequest, type HierarchyItem } from '../../lib/api/hierarchies';

interface HierarchyQueryOptions {
  enabled?: boolean;
}

export function useGetHierarchiesQuery(
  body: Omit<GetHierarchiesRequest, 'columnNames'>,
  options?: HierarchyQueryOptions,
) {
  const queryKey = ['hierarchies', body];

  return useQuery<HierarchyItem[], ApiError>({
    queryKey,
    queryFn: () => fetchGetHierarchies(body),
    meta: {
      onError: () => {
        biToast.error('Failed to Load', 'Unable to load hierarchies. Please refresh the page.');
      },
    },
    placeholderData: keepPreviousData,
    ...options,
  });
}

export function useSearchHierarchiesQuery(body: GetHierarchiesRequest, options?: HierarchyQueryOptions) {
  const queryKey = ['searchHierarchies', body];

  return useQuery<HierarchyItem[], ApiError>({
    queryKey,
    queryFn: () => fetchGetHierarchies(body),
    placeholderData: keepPreviousData,
    ...options,
  });
}

export function useSearchKnownHierarchiesQuery(body: GetHierarchiesRequest, options?: HierarchyQueryOptions) {
  const queryKey = ['searchKnownHierarchies', body];

  return useQuery<HierarchyItem[], ApiError>({
    queryKey,
    queryFn: () => fetchGetHierarchies(body),
    ...options,
  });
}
